<icms-outlet-block [name]="'400page'"
                   [variant]="'404-page'" />